import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const ModalStackContext = createContext();

export function ModalStackProvider({ children }) {
  const [stack, setStack] = useState([]);

  const register = useCallback(id => {
    setStack(prev => [...prev, id]);
  }, []);

  const unregister = useCallback(id => {
    setStack(prev => prev.filter(modalId => modalId !== id));
  }, []);

  return (
    <ModalStackContext.Provider value={{ stack, register, unregister }}>
      {children}
    </ModalStackContext.Provider>
  );
}

export function useModalStack(id) {
  const { stack, register, unregister } = useContext(ModalStackContext);

  const value = useMemo(
    () => ({
      isInForeground: stack[stack.length - 1] === id,
      register,
      unregister,
    }),
    [id, stack, register, unregister],
  );

  return value;
}
